import React from 'react';
import PropTypes from 'prop-types';
import { Button, TextArea } from '../../styled-components';
import localize from '../../util/localizeUtils';
import ButtonWithIcon from './ButtonWithIcon';
import CharacterLimit from './CharacterLimit';
import { ButtonContainer, Container } from './styled-components';

class TwitterTabContent extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      caption: '',
      postLength: 0
    };
  }

  onChangeText = (event) => {
    const caption = event.target.value;
    this.setState({ caption, postLength: caption.length });
  }

  onPost = () => {
    this.props.onPost(this.state.caption);
  }

  renderLogIn() {
    const control = this.props.loggedInUser ?
        (<div>
          <ButtonContainer paddingBottom="8px">
            <ButtonWithIcon style={{ marginRight: '8px' }} img="images/refresh.png" text={localize('changeUserButton')} onClick={this.props.onChangeUser} />
            <ButtonWithIcon img="images/twitter.png" text={localize('logOutButton')} onClick={this.props.onLogOut} />
          </ButtonContainer>
          <span>{localize('loggedInFormat').replace('{user}', `@${this.props.loggedInUser}`)}</span>
        </div>) :
        <ButtonWithIcon img="images/twitter.png" text={localize('publishLoginButton')} onClick={this.props.onLogIn} />;
    return (
      <div style={{ paddingBottom: '8px' }}>
        {control}
      </div>
    );
  }

  render() {
    return (
      <Container>
        {this.renderLogIn()}
        <TextArea style={{ display: 'block' }} height="100px" width="100%" onChange={this.onChangeText} />
        <ButtonContainer paddingTop="8px">
          <Button disabled={!this.props.loggedInUser} onClick={this.onPost}>{localize('postButton')}</Button>
        </ButtonContainer>
        <CharacterLimit currentLength={this.state.postLength} max={280} />
      </Container>
    );
  }
}

TwitterTabContent.propTypes = {
  loggedInUser: PropTypes.string,
  onChangeUser: PropTypes.func.isRequired,
  onLogIn: PropTypes.func.isRequired,
  onLogOut: PropTypes.func.isRequired,
  onPost: PropTypes.func.isRequired
};

TwitterTabContent.defaultProps = {
  loggedInUser: ''
};

export default TwitterTabContent;



// WEBPACK FOOTER //
// ./app/components/PublishingDialog/TwitterTabContent.js